import { apiFetch, buildQuery } from "./client";
import type { Page } from "./admin";

/** Sprint 5d contract: docs/api/sprint5d-istorija-izmena.md §1. */

/** `ARTICLE_TYPE` and `ARTICLE` since sprint 5l; `POSITION` also lists its sastavnica lines (`PositionBomItem`). */
export type HistoryEntityKind = "ASSET_TYPE" | "ASSET" | "POSITION" | "LOCATION" | "SUPPLIER" | "TEMPLATE" | "ARTICLE_TYPE" | "ARTICLE";

export type HistoryAction = "CREATE" | "UPDATE" | "DELETE" | "RESTORE";

/** Raw snapshot values (string/number/boolean/null/list/object); the UI labels and formats them. */
export type HistoryChange = { field: string; before: unknown; after: unknown };

export type HistoryEntry = {
  id: string;
  /** `audit_log.created_at`. */
  at: string;
  actorId: string | null;
  /** "Ime Prezime", null for system / seed writes. */
  actorName: string | null;
  action: HistoryAction;
  /**
   * "AssetType" | "AttributeDef" | "Asset" | "Position" | "Location" | "Template" | "TemplateNode" | "Attachment" |
   * "Comment" | "ArticleType" | "ArticleTypeAttribute" | "Article" | "PositionBomItem"; "AssetTypeBomItem" only in
   * old rows (the type-level sastavnica was dropped in sprint 5l, its audit rows stay — hard rule 1).
   */
  entityType: string;
  entityId: string | null;
  /** Readable label of a sub-entity (attribute "label (key)", attachment filename, comment excerpt); null for the main entity. */
  entityLabel: string | null;
  /** CREATE: every non-null field; UPDATE: only differing fields; DELETE / RESTORE: empty. */
  changes: HistoryChange[];
};

/** First paint shows a short list; "Prikaži starije" appends full pages (Strahinja, 2026-09-10). */
export const HISTORY_FIRST_PAGE_SIZE = 5;
export const HISTORY_PAGE_SIZE = 20;

export const historyApi = {
  /** `at DESC`; any logged-in user with the module's `*:view`. */
  list: (entityKind: HistoryEntityKind, entityId: string, page = 0, size = HISTORY_PAGE_SIZE) =>
    apiFetch<Page<HistoryEntry>>(`/history${buildQuery({ entityKind, entityId, page, size })}`),
};
